var exports = {
  "kL": "xa15a2ab7--5c4e99--container",
  "_8": "xa15a2ab7--5c4e99--img",
  "DD": "xa15a2ab7--5c4e99--title",
  "Qq": "xa15a2ab7--5c4e99--text",
};

module.exports = exports;
